import { WIDGET_REGISTRY } from './registry'
import type { WidgetDefinition } from './types'

// ── Executive Summary ─────────────────────────────────────────────────────────

const executiveSummary: Omit<WidgetDefinition, 'render'>[] = [
  { id: 'exec-total-orders',    label: 'Total Orders',      section: 'executive_summary', state: 'coming_soon', order: 0 },
  { id: 'exec-active-sessions', label: 'Active Sessions',   section: 'executive_summary', state: 'coming_soon', order: 1 },
  { id: 'exec-revenue-today',   label: 'Revenue Today',     section: 'executive_summary', state: 'coming_soon', order: 2, requiredCapability: 'accounting',     whyItMatters: 'Daily revenue at a glance.' },
  { id: 'exec-conversion-rate', label: 'Conversion Rate',   section: 'executive_summary', state: 'coming_soon', order: 3 },
]

// ── Financial Health ──────────────────────────────────────────────────────────

const financialHealth: Omit<WidgetDefinition, 'render'>[] = [
  { id: 'fin-revenue',          label: 'Revenue',           section: 'financial_health', state: 'locked',      order: 0, requiredCapability: 'accounting',      whyItMatters: 'Know your actual revenue after returns and discounts.' },
  { id: 'fin-profit',           label: 'Profit',            section: 'financial_health', state: 'locked',      order: 1, requiredCapability: 'profit',           whyItMatters: 'Understand which products actually make money.' },
  { id: 'fin-expenses',         label: 'Expenses',          section: 'financial_health', state: 'locked',      order: 2, requiredCapability: 'expenses',          whyItMatters: 'Track your full cost picture.' },
  { id: 'fin-net-margin',       label: 'Net Margin',        section: 'financial_health', state: 'locked',      order: 3, requiredCapability: 'profit',           whyItMatters: 'Your bottom-line after all costs.' },
  { id: 'fin-target-progress',  label: 'Target Progress',   section: 'financial_health', state: 'coming_soon', order: 4, requiredCapability: 'target_tracking',  whyItMatters: 'See how close you are to monthly targets.' },
  { id: 'fin-break-even',       label: 'Break-even',        section: 'financial_health', state: 'coming_soon', order: 5, requiredCapability: 'target_tracking',  whyItMatters: 'Know exactly when you turn profitable each month.' },
  { id: 'fin-forecast',         label: 'Revenue Forecast',  section: 'financial_health', state: 'locked',      order: 6, requiredCapability: 'forecast',          whyItMatters: 'Know your revenue target for the month ahead.' },
  { id: 'fin-cod-collected',    label: 'COD Collected',     section: 'financial_health', state: 'locked',      order: 7, requiredCapability: 'accounting',        whyItMatters: 'Track how much cash has physically arrived.' },
]

// ── Sales Health ──────────────────────────────────────────────────────────────

const salesHealth: Omit<WidgetDefinition, 'render'>[] = [
  { id: 'sales-ready',           label: 'Ready',            section: 'sales_health', state: 'coming_soon', order: 0 },
  { id: 'sales-no-answer',       label: 'No Answer',        section: 'sales_health', state: 'coming_soon', order: 1 },
  { id: 'sales-conversion-rate', label: 'Conversion Rate',  section: 'sales_health', state: 'coming_soon', order: 2 },
  { id: 'sales-upsell-revenue',  label: 'Upsell Revenue',   section: 'sales_health', state: 'coming_soon', order: 3 },
]

// ── Operations Health ─────────────────────────────────────────────────────────

const operationsHealth: Omit<WidgetDefinition, 'render'>[] = [
  { id: 'ops-pending',        label: 'Pending Fulfillment', section: 'operations_health', state: 'coming_soon', order: 0 },
  { id: 'ops-returns',        label: 'Returns This Month',  section: 'operations_health', state: 'coming_soon', order: 1 },
  { id: 'ops-inventory-risk', label: 'Inventory Risk',      section: 'operations_health', state: 'locked',      order: 2, requiredCapability: 'forecast', whyItMatters: 'Catch stockouts before they happen.' },
  { id: 'ops-cf-queue',       label: 'Confirmation Queue',  section: 'operations_health', state: 'coming_soon', order: 3 },
]

// ── Alerts ────────────────────────────────────────────────────────────────────

const alerts: Omit<WidgetDefinition, 'render'>[] = [
  { id: 'alert-feed', label: 'Active Alerts', section: 'alerts', state: 'coming_soon', order: 0 },
]

// ── Quick Actions ─────────────────────────────────────────────────────────────

const quickActions: Omit<WidgetDefinition, 'render'>[] = [
  { id: 'qa-actions', label: 'Quick Actions', section: 'quick_actions', state: 'coming_soon', order: 0 },
]

// ── Register all ─────────────────────────────────────────────────────────────

const noop = () => null

for (const def of [
  ...executiveSummary,
  ...financialHealth,
  ...salesHealth,
  ...operationsHealth,
  ...alerts,
  ...quickActions,
]) {
  WIDGET_REGISTRY.register({ ...def, render: noop })
}
